module.exports = "//d2t2kh5dwcod2h.cloudfront.net/59e405ea776fe6c49772c783943c73530ceafe06/images/photo-couple-wide.png";